
const hidingItems = [
    {
        title: 'robot',
        image: 'https://robohash.org/',
    },
    
];

export default hidingItems;
